export default "__VITE_ASSET__e41805a8__"